import { useCallback } from "react"

export const useUrlParams = () => {
  const searchParams = new URLSearchParams(window.location.search)

  const updateUrlParams = useCallback(params => {
    const newSearchParams = new URLSearchParams(window.location.search)
    Object.entries(params).forEach(([key, value]) => {
      if (value) {
        newSearchParams.set(key, value)
      } else {
        newSearchParams.delete(key)
      }
    })
    const newUrl = `${window.location.pathname}?${newSearchParams.toString()}`
    window.history.pushState(null, "", newUrl)
  }, [])

  const clearUrlParams = useCallback(() => {
    const newUrl = window.location.pathname
    window.history.pushState(null, "", newUrl)
  }, [])

  return { searchParams, updateUrlParams, clearUrlParams }
}
